<template>
  <click-to-edit
    v-model="scope.row.scale.forecast"
    :number-format="{decimals: 6, space:true}"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.forecast')"
    placeholder=""
    @input="saveElementPropChange(scope.row, 'scale', {forecast:$event})"
  >
  </click-to-edit>
</template>

<script>


import ClickToEdit from "@/components/ClickToEdit.vue";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";

export default {
  name: 'element-forecast-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {

    }
  },

  methods: {

  }
}

</script>

<style>

</style>
